import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageMeta } from "@/components/PageMeta";

// Shared shell for information & legal pages: consistent header, optional TOC, footer.
export function LegalLayout({ metaTitle, metaDescription, title, subtitle, updated, toc, children }) {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <PageMeta title={metaTitle} description={metaDescription} />
      <Navbar />
      <div className="border-b border-zinc-200 bg-white">
        <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
          <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-900 sm:text-4xl">{title}</h1>
          {subtitle && <p className="mt-2 max-w-2xl text-zinc-500">{subtitle}</p>}
          {updated && <p className="mt-3 text-xs font-medium text-zinc-400">Last updated: {updated}</p>}
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
        <div className={toc ? "lg:grid lg:grid-cols-[220px_1fr] lg:gap-10" : ""}>
          {toc && (
            <aside className="mb-8 hidden lg:block">
              <div className="sticky top-24 rounded-2xl border border-zinc-200 bg-white p-4">
                <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-zinc-400">On this page</p>
                <ul className="space-y-1.5">
                  {toc.map((t) => (
                    <li key={t.id}><a href={`#${t.id}`} className="block text-sm text-zinc-500 hover:text-emerald-600">{t.label}</a></li>
                  ))}
                </ul>
              </div>
            </aside>
          )}
          <div className="min-w-0">{children}</div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export function Section({ id, title, children }) {
  return (
    <section id={id} className="mb-8 scroll-mt-24">
      {title && <h2 className="mb-3 font-display text-xl font-bold text-zinc-900">{title}</h2>}
      <div className="space-y-3 leading-relaxed text-zinc-600">{children}</div>
    </section>
  );
}

export function ReviewFlag({ show, children }) {
  if (!show) return <span className="font-medium text-zinc-900">{children}</span>;
  return <span data-testid="review-flag" className="rounded bg-amber-100 px-1.5 py-0.5 text-xs font-semibold text-amber-700">REQUIRES FOUNDER REVIEW</span>;
}
